import { useState, useRef, useEffect } from "react";
import goodwe_esa_product_2 from "../../../assets/goodwe_esa_product_2.png";
import goodwe_esa_product_3 from "../../../assets/goodwe_esa_product_3.png";
import goodwe_esa_product_4 from "../../../assets/goodwe_esa_product_4.png";
import "../KeyBenefits.css";
import triangle_yellow from "../../../assets/triangle_yellow.png";

const features = [
  { title: "IP66 rated", description: "IP66 rated for indoor and outdoor installation, ensuring durability and protection against dust and moisture" },
  { title: "Rapid Energy Cycling", description: "Supports 1C charge and discharge, allowing the battery to quickly store and release energy for daily use" },
  { title: "Quiet Operation", description: "Fanless design keeps noise under 35dB, ensuring a peaceful and unobtrusive home environment" },
  { title: "Advanced Safety Protection", description: "6-layer safety protection with fire-safe design, featuring aerosol fire suppression and AI-driven AFCI 3.0 for advanced arc fault detection and prevention" },
  { title: "Reliable Whole-Home Backup", description: "The ESA provides uninterrupted power during outages, keeping essential appliances and your home running smoothly" },
  { title: "Flexible Battery Mixing", description: "Easily combine batteries of different capacities or mix old and new modules to expand storage without replacing the entire system" },
];

const images = [goodwe_esa_product_3, goodwe_esa_product_2, goodwe_esa_product_4];

export default function KeyBenefits() {
  const [activeIndex, setActiveIndex] = useState(0);
  const sectionRef = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([e]) => setInView(e.isIntersecting),
      { threshold: 0.2 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <div ref={sectionRef} className={`benefits-proven-brands-section ${inView ? "benefits-in-view" : ""}`}>
      <div className="benefits-brands-content">
        <div className="benefits-image-and-dots">
          <div className="benefits-image-row">
            <img key={activeIndex} src={images[activeIndex]} alt="Modern home with solar battery system" className="benefits-brands-image" />
          </div>
          <div className="benefits-dots">
            {[0, 1, 2].map((i) => (
              <button
                key={i}
                type="button"
                className={`benefits-dot ${i === activeIndex ? "active" : ""}`}
                onClick={() => setActiveIndex(i)}
                aria-label={`Show image ${i + 1}`}
                aria-pressed={i === activeIndex}
              />
            ))}
          </div>
        </div>
        <div className="benefits-brands-info-card">
          <h2>Key Benefits & Features</h2>
          {features.map((f, i) => (
            <div key={i} className="benefits-feature-row">
              <div className="benefits-feature-icon">
                <img src={triangle_yellow} alt="Arrow Icon" className="arrow-icon" />
              </div>
              <div className="benefits-feature-text">
                <h3>{f.title}</h3>
                <p>{f.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
